import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/css/psearch.css';
import apiClient from '../config/config';

function TrendingBrands() {
  const navigate = useNavigate();
  const [trendingBrands, setTrendingBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTrendingBrands = async () => {
      try {
        const response = await apiClient.get('/brands/trending/');
        if (response.data) {
          setTrendingBrands(response.data);
        }
      } catch (err) {
        console.error('Error fetching trending brands:', err);
        setError('Failed to fetch trending brands');
      } finally {
        setLoading(false);
      }
    };

    fetchTrendingBrands();
  }, []);

  const scrollToTopAndNavigate = (brandName) => {
    window.scrollTo(0, 0);
    navigate(`/brand/${encodeURIComponent(brandName)}`);
  };

  const getDisplayName = (brand) => {
    const brandDisplayNames = {
      'tulpalav': 'Tul Palav',
      'Tulpalav': 'Tul Palav',
    };
    return brandDisplayNames[brand] || brand;
  };

  if (loading) {
    return (
      <div className="text-center py-4">
        <div className="spinner-border spinner-border-sm" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error || trendingBrands.length === 0) {
    return null;
  }

  return (
    <div style={{ marginBottom: '60px' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          overflowX: 'auto',
          gap: '16px',
          paddingBottom: '12px',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch',
        }}
        className="horizontal-scroll-row"
      >
        {trendingBrands.map((brand, index) => (
          <div
            key={index}
            style={{
              flex: '0 0 260px',
              cursor: 'pointer',
            }}
            onClick={() => scrollToTopAndNavigate(brand.name)}
          >
            {/* Image */}
            <div style={{
              width: '100%',
              height: '380px',
              overflow: 'hidden',
              borderRadius: '4px',
              backgroundColor: '#f5f5f5',
            }}>
              <img
                src={brand.image || '/default-image.avif'}
                alt={brand.name}
                loading="lazy"
                decoding="async"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition: 'center top',
                  transition: 'transform 0.3s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.03)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                }}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = '/default-image.avif';
                }}
              />
            </div>

            {/* Brand Info */}
            <div style={{ paddingTop: '12px' }}>
              <h3 style={{
                fontSize: '13px',
                fontWeight: '600',
                fontFamily: 'Montserrat, sans-serif',
                color: '#1a1a1a',
                margin: '0 0 3px 0',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}>
                {getDisplayName(brand.name)}
              </h3>
              <p style={{
                fontSize: '12px',
                fontFamily: 'Montserrat, sans-serif',
                color: '#888',
                margin: 0,
              }}>
                {brand.product_count || 0} {brand.product_count === 1 ? 'product' : 'products'}
              </p>
            </div>
          </div>
        ))}
      </div>
      <style>{`
        .horizontal-scroll-row::-webkit-scrollbar { display: none; }
      `}</style>
    </div>
  );
}

export default TrendingBrands;
